<template>
  <el-container>
  
    <el-main v-if="tutor">
      <el-row type="flex" justify="space-start" :gutter="20">
        <el-col :span="14">
         <el-card class="box-card">

           <h5>Edit Tutor - {{tutor.firstname}} {{tutor.lastname}}</h5>

            <el-form ref="form" :model="tutor" label-width="120px">
            <el-form-item label="Firstname">
                <el-input v-model="tutor.firstname"></el-input>
            </el-form-item>
            <el-form-item label="Lastname">
                <el-input v-model="tutor.lastname"></el-input>
            </el-form-item>
                <el-form-item label="Username">
                <el-input v-model="tutor.username"></el-input>
            </el-form-item>
                <el-form-item label="Email">
                <el-input v-model="tutor.email"></el-input>
            </el-form-item>
                <el-form-item label="Password">
                <el-input v-model="tutor.password"></el-input>
            </el-form-item>
            <el-form-item label="Currency">
                <el-input v-model="tutor.currency"></el-input>
            </el-form-item>
            <el-form-item label="Rating">
                <el-input v-model="tutor.rating"></el-input>
            </el-form-item>
            <el-form-item label="Active">
              <el-checkbox v-model="checked"></el-checkbox>
            </el-form-item>
            <el-form-item>
            <el-button style="float: right;margin-left:5px " type="warn" @click="updateTutor()">Update</el-button>
                <el-button style="float: right; " type="danger" @click="deleteTutor()">Delete</el-button>
            </el-form-item>
            <br />

            </el-form>

        </el-card>
        </el-col>
        <el-col>
          <el-row style="margin-bottom:30px;">
            <el-card class="box-card">

              <h5>Notes</h5>

              <div v-for='(note,index) in notes' :key='index'>
                
                <div class="col-xs-11">
                  
                  <div v-html="note.detail">{{note.detail}}</div><br/>
                  <H6 class="text-muted" style="font-weight:400">
                    <i class="ti-time"></i> Added By
                    <span class="text-danger">{{note.createdBy}}</span> - {{note.dateCreated | moment("from", "now")}}</H6>
                  <br/>
                  
                  <hr />
                </div>

                <div class="col-xs-1">
                  <div class="btn btn-danger btn-sm btn-ws" @click="deleteNote(index)">
                    
                    <i class="fa fa-close"></i>
                  </div>
                </div>

              </div>

            </el-card> 
          </el-row>
          <el-row style="margin-bottom:30px;">
            <el-card>
              <el-form>
                  <h5>Add Note</h5>
                          
                    <VuePellEditor 
                      v-model="tutorNotes.detail"
                      :style-with-css="false"
                      default-paragraph-separator="p"
                          />
                          <br />
                          <el-button style="float: right;margin-left:5px " type="primary" @click="createTutorNote()">Add Note</el-button>
                          <br />
            <br />
              </el-form>
            </el-card>
          </el-row>
        </el-col>
      </el-row>
    </el-main>
  </el-container>    
</template>
<script>
import api from "./api";
import { commonApi } from "../../api/common.js";
import json from "../../data/countries.json";
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
import VuePellEditor from 'vue-pell-editor';
export default {
    data(){
        return{
            checked: false,
            tutor: {},
            tutorNotes: {
              dateCreated: moment().format(),
              dateUpdated: moment().format(),
              tutorId: "",
              detail: "",
              updatedBy: "",
              createdBy: "",
            },
            notes: {}
        };
    },

    components: {
      VuePellEditor
    },
    methods: {
    getTutor(id){
    this.$apollo
        .query({
          query: gql`
            {
              Tutor_by_pk(id: "${id}") {
                id
                      firstname  
                      lastname
                      email
                      rating
                      username
                      password
                      currency
                      
                      notes{
                        id
                        detail
                      }
                      address {
                        id
                        line1
                        line2
                        postcode
                        country
                        phone
                        fax
                      }
                      isActive
              }
            }
        `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.tutor = response.data.Tutor_by_pk;
          this.checked = !!this.tutor.isActive;
        });
      },

    getTutorNotes(id){
    this.$apollo
        .query({

          query: gql`
            {
            TutorNote(where: {tutorId: {_eq: "${id}"}}) {
              detail
              id
              dateCreated
              dateUpdated
              updatedBy
              createdBy
            }
          }
        `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.notes = response.data.TutorNote;
      });
  },


    updateTutor(id){
          const q = gql`
            mutation update_tutor($id: Int, $firstname: String, $lastname: String, $email: String, $rating: float8, $username: String, $password: String, $currency: String, $isActive:smallint){
              update_Tutor(where: {id: {_eq: $id}}, _set: {firstname: $firstname, lastname: $lastname, email: $email, rating: $rating, username: $username, password: $password, currency: $currency, isActive: $isActive}) {
                affected_rows
                returning {
                  firstname
                  lastname
                  email
                  rating
                  username
                  password
                  currency
                  id
                  isActive
                }
              }
            }

          `

          this.$apollo

        .mutate({
          mutation: q,
          variables: {
            firstname: this.tutor.firstname,
            lastname: this.tutor.lastname,
            email: this.tutor.email,
            rating: this.tutor.rating,
            username: this.tutor.username,
            password: this.tutor.password,
            currency: this.tutor.currency,
            isActive: this.checked ? 1 : 0,
            id: this.tutor.id
          }
        })



        .then(result => {
          this.$notify({
            title: "Update Tutor",
            message: "Tutor Updated",
            type: "success"
          });
          // return result
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });

      },

      createTutorNote() {
          
          
            const q = gql`
            mutation insert_tutornote(
              $dateCreated: timestamp,
              $dateUpdated: timestamp,
              $tutorId: Int,
              $detail: String,
              $updatedBy: String,
              $createdBy: String
            ) {
              insert_TutorNote(objects: {
                dateCreated: $dateCreated,
                dateUpdated: $dateUpdated,
                tutorId: $tutorId,
                detail: $detail,
                updatedBy: $updatedBy,
                createdBy: $createdBy 
              }) {
                affected_rows
                returning {
                  id
                  detail
                }
              }
            }

            `

            this.$apollo

            .mutate({
              mutation: q,
              variables: {
                dateCreated: this.tutorNotes.dateCreated,
                dateUpdated: this.tutorNotes.dateUpdated,
                tutorId: this.tutor.id,
                detail: this.tutorNotes.detail,
                updatedBy: this.user.email,
                createdBy: this.user.email
              }
            })

            .then(result => {
              this.$notify({
                title: "Create new note",
                message: "Note created",
                type: "success"
              })
            })
            .catch(error => {
              this.$notify({
                title: "Error",
                message: error.message,
                type: "error"
              })
            })

        },

        deleteNote(index){
          const q = gql`
            mutation delete_TutorNote($id: Int) { 
              delete_TutorNote(where: {id: {_eq: $id}}) {
                affected_rows
                returning {
                  id
                }
              }
            }
          `

          this.$apollo

            .mutate({
              mutation: q,
              variables: {
                id: this.notes[index].id
              }
            })

          .then(result => {
            this.$notify({
              title: "Delete the note",
              message: "Note Deleted",
              type: "success"
            })
          })
        },
    },

   mounted() {
    this.getTutor(this.$route.params.id); 
    this.getTutorNotes(this.$route.params.id)   
  },
  

  watch: {
    "this.$route.params.id": function(id) {
      console.log("watching...");
      this.getTutor(id);
      this.getTutorNotes(this.$route.params.id);   
    }
  },
  computed: {
    user() {
      const token = localStorage.getItem("vuex");
      const parsed = JSON.parse(token);
      return parsed["auth"];
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Tutor/TutorEdit.vue